




















































import Vue from "vue";

export default Vue.extend({
  name: "app-header",
  props: {
    userName: String,
    userEmail: String,
  },
  mounted() {
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".navbar-burger"), 0);
    if ($navbarBurgers.length > 0) {
      $navbarBurgers.forEach( (el: any) => {
        el.addEventListener("click", () => {
          const target = el.dataset.target;
          const $target = document.getElementById(target);
          el.classList.toggle("is-active");
          if ($target !== null) {
            $target.classList.toggle("is-active");
          }
        });
      });
    }
  },
  methods: {
    toggleSidebarDesktop() {
      this.$emit("toggleSidebarDesktop");
    },
    toggleSidebarMobile() {
      this.$emit("toggleSidebarMobile");
    },
    handleOnChangeDropMenu(val: string) {
      this.$emit("selectMenu", val);
    },
  },
});
